﻿import { IComponent, Component, Inject, Input, Output, Attribute, OutputArgs } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../../components/application"
import { DropdownEntry } from "../../controls/dropdownbox";
import { IDisposable } from "../../interfaces/general";

@Component({
    module: FIQAssist,
    selector: "severitydropdownbox",
    template: `<dropdownbox
                read-only="$ctrl.readOnly"
                value-submit="$ctrl.passValueSubmit(selected)"
                multiselecttext="'MULTIPLE_SEVERITIES_SELECTED'" multiselect="$ctrl.multiselect"
                hint="'Please choose a severity'" selected="$ctrl.severities"
                items="[{key:'level1',text:'Level 1'},{key:'level2',text:'Level 2'},{key:'level3',text:'Level 3'},{key:'level4',text:'Level 4'}]"
                onselectionchanged="$ctrl.severitiesselected(selected)" show-clear="{{$ctrl.showClear}}"
                ></dropdownbox>`
})
class SeverityDropdownBox implements IComponent {
    private _severities: any[];
    @Input() public readOnly: boolean;

    @Input()
    public get severities(): any[] {
        return this._severities;
    }
    public set severities(envs: any[]) {
        this._severities = envs;
    }
    private _showClear;
    @Attribute() public get showClear() {
        return this._showClear;
    }
    public set showClear(val: boolean | string) {
        this._showClear = val === true || val === "true";
    }

    @Input() public multiselect: boolean;
    @Output() public onSeverityChanged: OutputArgs<{ severities: any[] }>;
    public severitiesselected(selected: any[]) {
        this.severities = selected;
        this.onSeverityChanged({ severities: this.severities });
    }
    @Output() public valueSubmit: OutputArgs<{ severities: any[] }>;
    public passValueSubmit(value: any[]) {
        if (this.valueSubmit) this.valueSubmit({ severities: value });
    }
}
